export default [  
  {
    path: '/product-groups',
    name: 'product-groups',
    component: () => import('@/views/modules/product-groups/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Product Groups List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Product Groups' }
      ]
    },
    children:[
      {
        path: '/product-groups/create',
        name: 'product-groups-create',
        component: () => import('@/views/modules/product-groups/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Product Group Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Product Groups', link: '/product-groups' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/product-groups/:id/edit',
        props: true,
        name: 'product-groups-edit',
        component: () => import('@/views/modules/product-groups/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Product Groups Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Product Group',  to: { name: "product-groups-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: '/product-groups/:id/show',
        props: true,
        name: 'product-groups-show',
        component: () => import('@/views/modules/product-groups/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Product Groups Details',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Product Groups',  to: { name: "product-groups" } },
            { text: 'Details' }
          ]
        }
      },
    
    ]
  },
 
]